new Swiper('.swiper-swing-sets-latest-designs', {
    modules: [SwiperScrollbar],
    slidesPerView: 3,
    spaceBetween: 15,
    loop: false,
    scrollbar: {
        el: '.swiper-scrollbar-swing-sets-latest-designs',
        draggable: true,
        hide: false
    },
    breakpoints: {
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 6,
            spaceBetween: 15,
        },
        1298: {
            slidesPerView: 8,
            spaceBetween: 15,
        },
        1798: {
            slidesPerView: 9,
            spaceBetween: 15,
        },
        2298: {
            slidesPerView: 10,
            spaceBetween: 15,
        }
    },
});


new Swiper('.swiper-outdoor-ar-slides', {
    modules: [SwiperNavigation, SwiperPagination],
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination-outdoor-ar-slides',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

new Swiper('.swiper-outdoor-cl-slides', {
    modules: [SwiperNavigation, SwiperPagination],
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination-outdoor-cl-slides',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

new Swiper('.swiper-outdoor-ru-slides', {
    modules: [SwiperNavigation, SwiperPagination],
    slidesPerView: 1,
    pagination: {
        el: '.swiper-pagination-outdoor-ru-slides',
        clickable: true
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

swiperOutdoorAr.update();
swiperOutdoorCl.update();

